import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    CustomerGroupCreateRequest, CustomerGroupPatchInBatchRequest,
    CustomerGroupResponse
} from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.dto'

class CustomerGroupsService {
    async create(request: CustomerGroupCreateRequest): Promise<CustomerGroupResponse> {
        const response = await axios.post<CustomerGroupResponse>(`/configuration/customerGroups`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<CustomerGroupResponse>> {
        const response = await axios.put<IResponseAgGrid<CustomerGroupResponse>>(`/configuration/customerGroups`, { ...filterModel }, { params })
        return response.data
    }

    async get(customerGroupId: number): Promise<CustomerGroupResponse> {
        const response = await axios.get<CustomerGroupResponse>(`/configuration/customerGroups/${customerGroupId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/customerGroups/batch`, { data: request })
        return response.data
    }

    async patch(request: CustomerGroupPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/customerGroups/batch`, request)
        return response.data
    }
}

export const customerGroupsService = new CustomerGroupsService()
